var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint0_linear_144_2690)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8977 37.0792C38.76 37.0792 44.6195 38.1672 44.6195 42.5207C44.6195 46.8724 38.7976 48 31.8977 48C25.0353 48 19.1758 46.9121 19.1758 42.5603C19.1758 38.2068 24.9977 37.0792 31.8977 37.0792ZM31.8977 16C36.5699 16 40.3162 19.7645 40.3162 24.4657C40.3162 29.1651 36.5699 32.9332 31.8977 32.9332C27.2255 32.9332 23.4791 29.1651 23.4791 24.4657C23.4791 19.7645 27.2255 16 31.8977 16Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_144_2690",
    x1: 0,
    y1: 0,
    x2: 64,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93F090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60BFB7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsProfile);
export default __webpack_public_path__ + "static/media/settings_profile.1240431a7f518c8c4f20b2d952975d90.svg";
export { ForwardRef as ReactComponent };